import { render } from "./PasswordDialog.vue?vue&type=template&id=3024e572&ts=true"
import script from "./PasswordDialog.ts?vue&type=script&lang=ts&external"
export * from "./PasswordDialog.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__